export default __webpack_public_path__ + "static/media/Care2Share.25d92f4f.png";